(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(64796);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Home": function() { return /* binding */ Home; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_common_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45092);
/* harmony import */ var _components_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56150);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9911);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8013);
/* harmony import */ var _utils_storyblok__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56447);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_navigation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38757);
/* harmony import */ var _components_context_Authentication__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68185);
/* harmony import */ var _utils_useLoginAndRegisterModal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18228);












var SEO_TITLE = "Pe\xe7a A\xed - O maior estoque de pe\xe7as para a sua oficina";
var SEO_IMAGE = "https://assets.peca.ai/parts/pecai-logo-meta.jpeg";
var SEO_DESC = "Com o Pe\xe7a A\xed, voc\xea acha a pe\xe7a certa para cada carro e compra num s\xf3 lugar. " + "\xc9 o maior estoque digital de pe\xe7as do pa\xeds! " + "ENTREGA EM AT\xc9 2 HORAS! PRE\xc7OS 20% MENORES! + DE 100.000 PE\xc7AS";
var __N_SSG = true;
var Home = (0,_utils_storyblok__WEBPACK_IMPORTED_MODULE_6__/* .storyblokPage */ .Q2)(function(param) {
    var story = param.story;
    var loading = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_5__/* .useCart */ .jD)().loading;
    var isLoggedIn = (0,react__WEBPACK_IMPORTED_MODULE_7__.useContext)(_components_context_Authentication__WEBPACK_IMPORTED_MODULE_10__/* .AuthenticationContext */ .zC).isLoggedIn;
    var ref = (0,_utils_navigation__WEBPACK_IMPORTED_MODULE_9__/* .useNavigation */ .HJ)(), goTo = ref.goTo, getBackPage = ref.getBackPage;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var handleGoToLoginModal = (0,_utils_useLoginAndRegisterModal__WEBPACK_IMPORTED_MODULE_11__/* .useLoginAndRegisterModal */ .tu)().handleGoToLoginModal;
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (router.isReady) {
            var backPage = getBackPage();
            var callback = router.query.callback;
            if ( true && isLoggedIn && callback) {
                goTo(callback);
            } else if (!isLoggedIn && callback && backPage !== "/logout") {
                handleGoToLoginModal();
            }
        }
    }, [
        router.isReady,
        isLoggedIn
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts__WEBPACK_IMPORTED_MODULE_4__/* .StoryLayout */ .yp, {
        unsecure: true,
        story: story,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Pe\xe7a a\xed - O maior estoque de pe\xe7as para a sua oficina"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: SEO_TITLE
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: SEO_DESC
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: SEO_TITLE
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: SEO_DESC
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: SEO_IMAGE
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_structure__WEBPACK_IMPORTED_MODULE_3__/* .StoryBloks */ .xJ, {
                bloks: story.content.body
            }),
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                full: true
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ }),

/***/ 45847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20747)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [486,7249,9911,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);